import rocket from "../assets/images/rocket.png";
import thumb from "../assets/images/thumb.png";
import support from "../assets/images/support.png";

import result from "../assets/images/icon-results.png";
import details from "../assets/images/icon-details.png";
import grow from "../assets/images/icon-package.png";

export default function HowItWorksDynamic({ serviceData }) {
  return (
    <>
      <section className="container my-24 mx-auto px-5 md:px-24 text-center">
        <div className="flex flex-row lg:flex-row max-sm:flex-col items-center">
          <div className="text-center my-0 max-sm:my-5  basis-full">
            <img className="mx-auto flex-none" src={thumb} alt="thumb" />
            <h2
              className="my-5 text-xl font-bold"
              dangerouslySetInnerHTML={{ __html: serviceData?.stepTitle1 }}
            ></h2>

            <div
              className="mx-10"
              dangerouslySetInnerHTML={{ __html: serviceData?.stepItem1 }}
            ></div>
          </div>
          <div className="text-center my-0 max-sm:my-5  basis-full ">
            <img
              className="mx-auto flex-none max-w-[100px] max-h-[110px]"
              src={details}
              alt="details"
            />
            <h2
              className="my-5 text-xl font-bold"
              dangerouslySetInnerHTML={{ __html: serviceData?.stepTitle2 }}
            ></h2>

            <div
              className="mx-10"
              dangerouslySetInnerHTML={{ __html: serviceData?.stepItem2 }}
            ></div>
          </div>
          <div className="text-center my-0 max-sm:my-5  basis-full">
            <img
              className="mx-auto flex-none max-w-[100px] max-h-[110px]"
              src={result}
              alt="result"
            />
            <h2
              className="my-5 text-xl font-bold"
              dangerouslySetInnerHTML={{ __html: serviceData?.stepTitle3 }}
            ></h2>

            <div
              className="mx-10"
              dangerouslySetInnerHTML={{ __html: serviceData?.stepItem3 }}
            ></div>
          </div>
        </div>
      </section>
    </>
  );
}
